export function useJsonFormatter() {
  function structuredDataRequest(jsonData) {
    if (!jsonData) return '';
    try {
      const jsonObject = JSON.parse(JSON.stringify(jsonData));
      delete jsonObject.id;
      delete jsonObject.created_at;
      delete jsonObject.updated_at;
      delete jsonObject.type;
      delete jsonObject.response_status;
      delete jsonObject.response_body;
      delete jsonObject.method;
      delete jsonObject.host;
      return jsonObject;
    } catch (error) {
      console.error('Error parsing JSON data:', error);
      return '';
    }
  }

  function structuredDataResponse(jsonData) {
    if (!jsonData) return '';
    try {
      const jsonObject = JSON.parse(JSON.stringify(jsonData));
      delete jsonObject.id;
      delete jsonObject.created_at;
      delete jsonObject.updated_at;
      delete jsonObject.type;
      delete jsonObject.method;
      delete jsonObject.url;
      delete jsonObject.request_body;
      delete jsonObject.request_headers;
      delete jsonObject.host;
      return jsonObject;
    } catch (error) {
      console.error('Error parsing JSON data:', error);
      return '';
    }
  }

  function formatDate(date) {
    const newDate = new Date(date);
    const options = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
      timeZone: 'UTC'
    };
    const datePart = newDate.toLocaleDateString('en-US', options).split(', ');
    return `${datePart[0]} on ${datePart[1]} ${datePart[2]}`;
  }

  return {
    structuredDataRequest,
    structuredDataResponse,
    formatDate
  };
}